// Must stay in sync with the backend enum
// (server/models/types/ServiceItemType.enum.ts). The numeric values are
// persisted on ServiceItem.type, so their order must never change.
enum ServiceItemType {
    Part,
    Labor,
    Fee,
    Sublet,
}

export default ServiceItemType;
